module.exports = __webpack_public_path__ + "static/media/start.3cd01366.svg";